import React from 'react'
import { Form } from 'react-final-form'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Grid, makeStyles } from '@material-ui/core'
import BuildingIcon from 'remixicon-react/BuildingLineIcon'
import BankIcon from 'remixicon-react/BankCardLineIcon'
import FundsIcon from 'remixicon-react/FundsLineIcon'
import LeafIcon from 'remixicon-react/LeafLineIcon'
import * as yup from 'yup'
import { validateFormValues } from 'utils/forms'
import { FieldSelect } from 'components/Fields'
import Button from 'components/Button'
import { callRelatorioGestaoResumido } from 'store/modules/relatorios/gestao'
import { callRelatorioIndicadoresGestaoResumido } from 'store/modules/relatorios/indicadoresGestao'
import { callRelatorioIPBResumido } from 'store/modules/relatorios/IPB'
import { getIdiomas } from 'store/modules/idiomas/idiomas.selectors'
import { callRelatorioPABSResumido } from 'store/modules/relatorios/PABS'
import { getIsCarregandoRelatorioGestaoResumido } from 'store/modules/relatorios/gestao/relatoriosGestao.selectors'
import { getIsCarregandoRelatorioIndicadoresGestaoResumido } from 'store/modules/relatorios/indicadoresGestao/relatoriosIndicadoresGestao.selectors'
import { getIsCarregandoRelatorioIPBResumido } from 'store/modules/relatorios/IPB/relatoriosIPB.selectors'
import { getIsCarregandoRelatorioPABSResumido } from 'store/modules/relatorios/PABS/relatoriosPABS.selectors'
import { getEmpresaAuditoriaSelecionada, getAnoSelecionado } from 'store/modules/auditor/auditor.selectors'
import Card from './Card'

const useStyles = makeStyles((theme) => ({
  submitButton: {
    marginTop: theme.spacing(3),
  },
}))

const TabResumidos = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()
  const idiomas = useSelector(getIdiomas)
  const loadingGestaoResumido = useSelector(getIsCarregandoRelatorioGestaoResumido)
  const loadingIndicadoresGestaoResumido =
    useSelector(getIsCarregandoRelatorioIndicadoresGestaoResumido)
  const loadingIPBGestaoResumido = useSelector(getIsCarregandoRelatorioIPBResumido)
  const loadingPABSGestaoResumido = useSelector(getIsCarregandoRelatorioPABSResumido)

  const anoSelecionado = useSelector(getAnoSelecionado)
  const empresaSelecionada = useSelector(getEmpresaAuditoriaSelecionada)

  const RELATORIOS = [
    {
      sigla: t('relatorios.siglaGeral'),
      title: t('relatorios.relatorioGeral'),
      icon: BuildingIcon,
      action: callRelatorioGestaoResumido,
      loading: loadingGestaoResumido,
    },
    {
      sigla: t('relatorios.siglaIndicePressaoBiodiversidade'),
      title: t('relatorios.pressaoBiodiversidade'),
      icon: FundsIcon,
      action: callRelatorioIPBResumido,
      loading: loadingIPBGestaoResumido,
    },
    {
      sigla: t('relatorios.siglaDesempenhoBiodiversidade'),
      title: t('relatorios.desempenhoBiodiversidade'),
      icon: LeafIcon,
      action: callRelatorioPABSResumido,
      loading: loadingPABSGestaoResumido,
    },
    {
      sigla: t('relatorios.siglaIndicadoresGestao'),
      title: t('relatorios.indicadoresGestao'),
      icon: BankIcon,
      action: callRelatorioIndicadoresGestaoResumido,
      loading: loadingIndicadoresGestaoResumido,
    },
  ]

  return (
    <Grid spacing={4} container>
      {RELATORIOS.map(({ sigla, action, title, icon, loading }) => (
        <Grid item xs={12} md={4} key={sigla}>
          <Form
            validate={validateFormValues(yup.object({
              idioma: yup.number().required(),
            }))}
            onSubmit={(values) => dispatch(action({
              anoBase: anoSelecionado,
              empresaId: empresaSelecionada.id,
              idioma: values.idioma,
            }))}
            render={({ handleSubmit, submitting, values }) => (
              <form onSubmit={handleSubmit}>
                <Card color="green" title={title} icon={icon}>
                  <Grid spacing={1} justifyContent="center" container>
                    <Grid item xs={12}>
                      <FieldSelect
                        required
                        name="idioma"
                        label={t('inputs.idioma')}
                        options={idiomas.map((idioma) => ({
                          label: t(idioma.label),
                          value: idioma.id,
                        }))}
                      />
                    </Grid>
                    <Grid item>
                      <Button
                        loading={loading}
                        loadingText="inputs.gerandoRelatorio"
                        type="submit"
                        className={classes.submitButton}
                        disabled={!values.idioma || submitting}
                      >
                        {t('relatorios.downloadRelatorio')}
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </form>
            )}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default TabResumidos
